import React, {useState} from 'react';
import FsLightbox from "fslightbox-react";
import {baseUrl_back} from "../../api/BaseUrl";
// const sources=[
//     "/Static/Images/Products/Baff_Biryuzovyy_Kationik_kombi/Main.png",
//     "/Static/Images/Products/Baff_Biryuzovyy_Kationik_kombi/Main.png",
//     "/Static/Images/Products/Baff_Biryuzovyy_Kationik_kombi/Main.png"
// ]
const sources=[]
const LightBoxFs = (props) => {
    const [toggler, setToggler] = useState(false);
    var sourcesnew=[]
    // console.log("1111111111111111111")
    // console.log(props.imgs)
    if (props.imgs==undefined)
    {
        sourcesnew=[baseUrl_back+"/Static/Images/Categories/Category_Default.png"]
    } else
        if (props.imgs.length>0)
        {
            props.imgs.forEach(
                element => {sourcesnew.push(baseUrl_back+element)
                // console.log("333333333")
                // console.log(sourcesnew)
                }
            );
           // console.log(sourcesnew)
        } else
        {
            sourcesnew=[baseUrl_back+"/Static/Images/Categories/Category_Default.png"]
        }



   return (
        <>

            <FsLightbox
                toggler={props.show}
                sources={sourcesnew}
                type="image"
                // types={[null, null, "video"]}
            />
        </>
    );
};

export default LightBoxFs;